"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages_en = void 0;
exports.messages_en = {
    Address: "Address is required",
    Province: "Province is required",
    PostalCode: {
        required: "Postal code is required",
        pattern: "Postal code format is not correct",
    },
    Profiles: {
        required: "Type of company is required",
    },
    Number: "Number is required",
    City: "City is required",
    Tariff: "Tariff is required",
    ContractedPower: {
        required: "Contracted power is required",
        pattern: "Power format is not correct",
    },
    Name: "Name is required",
    LastName: "Last name is required",
    Email: {
        required: "Email is required",
        pattern: "Please write a valid email address. For example, perez@domain.com",
        email: "Please write a valid email address. For example, perez@domain.com",
    },
    referralEmployee: {
        required: "Manager's name is required",
    },
    referralEmail: {
        required: "Manager's email is required",
        pattern: "Accepted domains are endesa.com, enel.com, endesa.es, and enel.es",
        email: "Please write a valid email address.",
    },
    Terms: "You must accept the terms",
    documentNumber: {
        required: "Document is required",
        pattern: "Document format is not correct",
        nifES: "Please enter a valid NIF",
        dniES: "Please enter a valid DNI",
        nieES: "Please enter a valid NIE",
    },
    PhoneNumber: {
        required: "Phone number is required",
        minlength: "Phone number must have 9 digits",
        number: "Phone number must be numeric",
        phoneNumberEs: "Phone number format is not correct",
    },
    CUPS: {
        required: "CUPS is required",
        pattern: "CUPS format is not correct",
    },
    ContactName: {
        required: "Name is required",
    },
    ContactLastName: {
        required: "Last name is required",
    },
    ContactDocumentNumber: {
        required: "Document is required",
        pattern: "Document format is not correct",
        dniES: "Please enter a valid DNI",
        nieES: "Please enter a valid NIE",
    },
    TotalConsumption: {
        required: "Consumption is required",
        pattern: "Consumption format must be numeric",
    },
};
